// import React from 'react';
// import { Grid, Typography, Container } from '@mui/material';

// const PrivacyPolicy = () => {
//   return (
//     <Container>
//       <Grid container spacing={3} sx={{ marginTop: 4 }}>
//         <Grid item xs={12}>
//           <Typography variant="h4" component="h1" gutterBottom>
//             Freshsweeper Privacy Policy
//           </Typography>
//           {/* <Typography variant="body1" color="textSecondary" paragraph>
//             Effective Date: [Insert Date]
//           </Typography> */}
//           <Typography variant="body1" paragraph>
//             Freshsweeper (“we,” “our,” or “us”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our cleaning services application (“App”). Please read this policy carefully to understand our practices regarding your personal information.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             1. Information We Collect
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We collect various types of information to provide and improve our services:
//           </Typography>
//           <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
//             a. Personal Information
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Name
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Email address
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Phone number
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Payment details (processed securely via a third-party payment gateway)
//           </Typography>
//           <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
//             b. Property Information
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Address of the property
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Number of rooms, bathrooms, and other property details
//           </Typography>
//           <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
//             c. Location Information
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • We may collect location data to match you with nearby cleaners or cleaning jobs (with your explicit consent).
//           </Typography>
//           <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
//             d. Device Information
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Device name
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Operating system version
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • App usage data
//           </Typography>
//           <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
//             e. Photos
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 4 }}>
//             • Before and after cleaning task photos (uploaded by cleaners or hosts for task verification).
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             2. How We Use Your Information
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We use your information for the following purposes:
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • To match hosts with cleaners based on proximity and preferences.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • To facilitate bookings and schedule cleaning services.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • To process payments securely.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • To send notifications, updates, and reminders.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • To enhance user experience through feedback and data analytics.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • To comply with legal obligations or resolve disputes.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             3. How We Share Your Information
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We may share your information in the following circumstances:
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • With Cleaners or Hosts: To facilitate cleaning requests and tasks.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • With Service Providers: For payment processing, notifications, and analytics.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • Legal Requirements: If required by law, court order, or legal process.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • Business Transfers: In the event of a merger, sale, or acquisition.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             4. Data Retention
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We retain your information for as long as necessary to fulfill the purposes outlined in this policy unless a longer retention period is required or permitted by law.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             5. Data Security
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We implement reasonable security measures to protect your information from unauthorized access, use, or disclosure. However, no internet-based application is completely secure, and we cannot guarantee absolute security.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             6. Your Rights
//           </Typography>
//           <Typography variant="body1" paragraph>
//             You have the following rights regarding your data:
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • Access, correct, or delete your personal information.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • Opt-out of receiving marketing communications.
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • Withdraw consent for data collection (where applicable).
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             • File a complaint with a data protection authority.
//           </Typography>
//           <Typography variant="body1" paragraph sx={{ marginLeft: 2 }}>
//             To exercise these rights, contact us at [Insert Contact Email].
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             7. Third-Party Services
//           </Typography>
//           <Typography variant="body1" paragraph>
//             Our App may include links to third-party websites or services. We are not responsible for the privacy practices of these third parties. Please review their privacy policies before sharing your information.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             8. Children’s Privacy
//           </Typography>
//           <Typography variant="body1" paragraph>
//             Our App is not intended for individuals under the age of 18. We do not knowingly collect personal information from children.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             9. Changes to This Policy
//           </Typography>
//           <Typography variant="body1" paragraph>
//             We may update this Privacy Policy from time to time. Any changes will be effective upon posting the revised policy in the App. We encourage you to review this policy periodically.
//           </Typography>
//         </Grid>

//         <Grid item xs={12}>
//           <Typography variant="h6" component="h2" gutterBottom>
//             10. Contact Us
//           </Typography>
//           <Typography variant="body1" paragraph>
//             If you have any questions about this Privacy Policy, please contact us at:
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             Freshsweeper
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             Email: service@freshsweeper.com
//           </Typography>
//           <Typography variant="body1" sx={{ marginLeft: 2 }}>
//             Phone: +1 973 380 4757
//           </Typography>
//         </Grid>
//       </Grid>
//     </Container>
//   );
// };

// export default PrivacyPolicy;



import React from "react";
import {
  Container,
  Typography,
  Box,
  useTheme,
  alpha,
  Chip,
  Divider,
  Paper,
  Grid,
  Link
} from "@mui/material";

const PrivacyPolicy = () => {
  const theme = useTheme();

  const sections = [
    { id: "overview", title: "1. Overview" },
    { id: "info-collect", title: "2. Information We Collect" },
    { id: "use-info", title: "3. How We Use Your Information" },
    { id: "sharing", title: "4. Sharing of Information" },
    { id: "cookies", title: "5. Cookies and Tracking" },
    { id: "data-security", title: "6. Data Security" },
    { id: "data-retention", title: "7. Data Retention" },
    { id: "user-rights", title: "8. Your Rights and Choices" },
    { id: "children", title: "9. Children’s Privacy" },
    { id: "third-party", title: "10. Third-Party Links" },
    { id: "changes", title: "11. Changes to This Privacy Policy" },
    { id: "contact", title: "12. Contact Us" }
  ];

  return (
    <Container maxWidth="lg" sx={{ py: 8 }}>
      {/* Header */}
      <Box sx={{ textAlign: "center", mb: 6 }}>
        <Chip
          label="Privacy"
          sx={{
            mb: 3,
            background: alpha(theme.palette.primary.main, 0.1),
            color: theme.palette.primary.dark,
            fontWeight: 600,
            fontSize: "0.85rem"
          }}
        />
        <Typography
          variant="h2"
          sx={{
            fontWeight: 700,
            color: theme.palette.text.primary,
            mb: 3,
            fontSize: { xs: "2rem", md: "3rem" }
          }}
        >
          Privacy Policy
        </Typography>
        <Typography
          variant="h6"
          sx={{
            color: theme.palette.text.secondary,
            maxWidth: "800px",
            mx: "auto",
            lineHeight: 1.6,
            fontSize: "1.1rem"
          }}
        >
          Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            color: theme.palette.text.secondary,
            maxWidth: "700px",
            mx: "auto",
            mt: 2,
            fontSize: "0.95rem"
          }}
        >
          FreshSweeper is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your information when you use our platform.
        </Typography>
      </Box>

      <Grid container spacing={4}>
        {/* Sidebar */}
        <Grid item xs={12} md={3}>
          <Paper
            elevation={0}
            sx={{
              position: "sticky",
              top: 100,
              p: 2,
              backgroundColor: alpha(theme.palette.background.default, 0.8),
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
            }}
          >
            <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
              On this page
            </Typography>
            <Box component="ul" sx={{ pl: 2, m: 0, listStyle: "none" }}>
              {sections.map((section) => (
                <Box component="li" key={section.id} sx={{ mb: 0.5 }}>
                  <Link
                    href={`#${section.id}`}
                    underline="hover"
                    sx={{
                      fontSize: "0.85rem",
                      color: theme.palette.text.secondary,
                      "&:hover": { color: theme.palette.primary.main },
                      textDecoration: "none"
                    }}
                  >
                    {section.title}
                  </Link>
                </Box>
              ))}
            </Box>
          </Paper>
        </Grid>

        {/* Main content */}
        <Grid item xs={12} md={9}>
          <Paper
            elevation={0}
            sx={{
              p: { xs: 2, md: 4 },
              borderRadius: 3,
              backgroundColor: theme.palette.background.paper,
              border: `1px solid ${alpha(theme.palette.divider, 0.1)}`
            }}
          >
            {/* 1. Overview */}
            <Box id="overview" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                1. Overview
              </Typography>
              <Typography variant="body1" paragraph>
                FreshSweeper Inc. ("Company", "we", "us", "our") operates the FreshSweeper website,
                mobile application, and related services (collectively, the "Platform"). This Privacy
                Policy applies to all users, including Hosts (property owners) and Cleaners (service
                providers).
              </Typography>
              <Typography variant="body1">
                By using the Platform, you consent to the data practices described in this Privacy
                Policy. If you do not agree, please do not use the Platform.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 2. Information We Collect */}
            <Box id="info-collect" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                2. Information We Collect
              </Typography>
              <Typography variant="h6" fontWeight={600} sx={{ mt: 2, mb: 1 }}>
                2.1 Information You Provide to Us
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Account Information:</strong> When you register, we collect your name, email
                address, phone number, profile photo, and role (Host or Cleaner). Cleaners may also
                provide background check information and banking details for payments. Hosts may
                provide property addresses, room details, and cleaning preferences.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Booking Information:</strong> We collect details about bookings, including
                dates, times, services requested, and communications between Hosts and Cleaners.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Payment Information:</strong> Payment processing is handled by secure third‑party
                providers (e.g., Stripe). We do not store full credit card numbers on our servers.
              </Typography>
              <Typography variant="body1">
                <strong>User Content:</strong> Reviews, messages, photos, and other content you post
                on the Platform.
              </Typography>

              <Typography variant="h6" fontWeight={600} sx={{ mt: 3, mb: 1 }}>
                2.2 Information Collected Automatically
              </Typography>
              <Typography variant="body1" paragraph>
                When you use the Platform, we may automatically collect:
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                <li><Typography variant="body1">Device information (IP address, browser type, operating system).</Typography></li>
                <li><Typography variant="body1">Usage data (pages visited, time spent, features used).</Typography></li>
                <li><Typography variant="body1">Location information (with your permission) to suggest nearby cleaners or properties.</Typography></li>
                <li><Typography variant="body1">Crash reports and performance logs.</Typography></li>
              </Box>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 3. How We Use Your Information */}
            <Box id="use-info" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                3. How We Use Your Information
              </Typography>
              <Typography variant="body1" paragraph>
                We use your information to:
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                <li><Typography variant="body1">Create and manage your account.</Typography></li>
                <li><Typography variant="body1">Facilitate bookings, payments, and communications between Hosts and Cleaners.</Typography></li>
                <li><Typography variant="body1">Verify Cleaner identity and perform background checks (with your consent).</Typography></li>
                <li><Typography variant="body1">Improve the Platform, develop new features, and troubleshoot issues.</Typography></li>
                <li><Typography variant="body1">Send service‑related notifications (booking confirmations, reminders, updates).</Typography></li>
                <li><Typography variant="body1">Respond to customer support inquiries.</Typography></li>
                <li><Typography variant="body1">Comply with legal obligations and enforce our Terms of Service.</Typography></li>
                <li><Typography variant="body1">With your consent, send promotional materials (you may opt out at any time).</Typography></li>
              </Box>
            </Box>

            {/* 3a. SMS Communications - NEW SECTION */}
              <Divider sx={{ my: 3 }} />
              <Box id="sms-communications" sx={{ scrollMarginTop: 80, mb: 4 }}>
                <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                  3a. SMS Communications
                </Typography>
                <Typography variant="body1" paragraph>
                  If you provide your phone number and opt in to receive text messages from FreshSweeper, we will use that number solely for the purposes you consented to – for example, to send job alerts, booking confirmations, reminders, or promotional offers. We do not share your phone number with unaffiliated third parties for their own marketing purposes.
                </Typography>
                <Typography variant="body1" paragraph>
                  <strong>Message frequency varies.</strong> You can opt out at any time by replying <strong>STOP</strong> to any message you receive. For help, reply <strong>HELP</strong> or email support@freshsweeper.com. Standard message and data rates may apply.
                </Typography>
                <Typography variant="body1">
                  We retain records of your SMS consent and opt‑out choices as required by law. After you opt out, you will receive no further text messages unless you re‑opt in. For additional information, see our <Link href="/terms">Terms of Service</Link>.
                </Typography>
              </Box>

            <Divider sx={{ my: 3 }} />

            {/* 4. Sharing of Information */}
            <Box id="sharing" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                4. Sharing of Information
              </Typography>
              <Typography variant="body1" paragraph>
                We do not sell your personal information. We may share your information in the
                following circumstances:
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Between Users:</strong> Hosts and Cleaners need to see certain information
                to complete bookings. For example, a Host will see the Cleaner’s name, rating, and
                profile; a Cleaner will see the Host’s property address and instructions.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Service Providers:</strong> We share information with third parties that help
                us operate the Platform, such as payment processors (Stripe), cloud hosting, analytics
                providers, and messaging services. These providers are contractually obligated to
                protect your data.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Legal Compliance:</strong> We may disclose information if required by law,
                subpoena, or governmental request, or to protect the rights, property, or safety of
                FreshSweeper, our users, or the public.
              </Typography>
              <Typography variant="body1" paragraph>
                <strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or
                sale of assets, your information may be transferred as part of that transaction.
              </Typography>
              <Typography variant="body1">
                <strong>With Your Consent:</strong> We may share information for other purposes with
                your explicit consent.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 5. Cookies and Tracking */}
            <Box id="cookies" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                5. Cookies and Tracking
              </Typography>
              <Typography variant="body1" paragraph>
                We use cookies and similar tracking technologies to enhance your experience,
                analyse usage, and personalise content. You can control cookies through your browser
                settings; however, disabling them may affect certain features of the Platform.
              </Typography>
              <Typography variant="body1">
                We also use analytics tools (e.g., Google Analytics) to understand how users interact
                with the Platform. These tools may collect information such as your IP address,
                device identifiers, and browsing behaviour.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 6. Data Security */}
            <Box id="data-security" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                6. Data Security
              </Typography>
              <Typography variant="body1" paragraph>
                We implement reasonable administrative, technical, and physical safeguards to protect
                your information against unauthorised access, loss, or alteration. These include
                encryption in transit (TLS) and at rest, access controls, and regular security audits.
              </Typography>
              <Typography variant="body1">
                However, no method of transmission over the Internet or electronic storage is 100% secure.
                You are responsible for maintaining the confidentiality of your login credentials.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 7. Data Retention */}
            <Box id="data-retention" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                7. Data Retention
              </Typography>
              <Typography variant="body1" paragraph>
                We retain your personal information for as long as your account is active or as needed
                to provide you with services. We may also retain and use your information to comply
                with legal obligations, resolve disputes, and enforce our agreements.
              </Typography>
              <Typography variant="body1">
                If you close your account, we will delete or anonymise your personal information
                within a reasonable period, unless we are required to retain it by law.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 8. Your Rights and Choices */}
            <Box id="user-rights" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                8. Your Rights and Choices
              </Typography>
              <Typography variant="body1" paragraph>
                Depending on your jurisdiction, you may have the following rights regarding your
                personal information:
              </Typography>
              <Box component="ul" sx={{ pl: 2 }}>
                <li><Typography variant="body1"><strong>Access:</strong> Request a copy of the information we hold about you.</Typography></li>
                <li><Typography variant="body1"><strong>Correction:</strong> Update inaccurate or incomplete information.</Typography></li>
                <li><Typography variant="body1"><strong>Deletion:</strong> Request that we delete your personal information, subject to legal limitations.</Typography></li>
                <li><Typography variant="body1"><strong>Opt-out:</strong> Unsubscribe from marketing communications using the link in our emails.</Typography></li>
                <li><Typography variant="body1"><strong>Data Portability:</strong> Receive a machine‑readable copy of your data.</Typography></li>
                <li><Typography variant="body1"><strong>Withdraw Consent:</strong> Where we rely on consent, you may withdraw it at any time.</Typography></li>
              </Box>
              <Typography variant="body1" sx={{ mt: 2 }}>
                To exercise these rights, please contact us at <strong>privacy@freshsweeper.com</strong>.
                We will respond within 30 days.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 9. Children’s Privacy */}
            <Box id="children" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                9. Children’s Privacy
              </Typography>
              <Typography variant="body1">
                The Platform is not intended for individuals under the age of 18. We do not knowingly
                collect personal information from children. If we become aware that a child has
                provided us with personal information, we will take steps to delete it.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 10. Third-Party Links */}
            <Box id="third-party" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                10. Third-Party Links
              </Typography>
              <Typography variant="body1">
                The Platform may contain links to third‑party websites or services that are not owned
                or controlled by us. This Privacy Policy does not apply to those third parties.
                We encourage you to review the privacy policies of any external sites you visit.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 11. Changes to This Privacy Policy */}
            <Box id="changes" sx={{ scrollMarginTop: 80, mb: 4 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                11. Changes to This Privacy Policy
              </Typography>
              <Typography variant="body1">
                We may update this Privacy Policy from time to time. We will notify you of material
                changes by posting a notice on the Platform or sending an email. The “Last updated”
                date at the top of this page indicates when the policy was last revised. Your
                continued use of the Platform after the changes become effective constitutes your
                acceptance of the revised policy.
              </Typography>
            </Box>

            <Divider sx={{ my: 3 }} />

            {/* 12. Contact Us */}
            <Box id="contact" sx={{ scrollMarginTop: 80, mb: 2 }}>
              <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
                12. Contact Us
              </Typography>
              <Typography variant="body1" paragraph>
                If you have any questions or concerns about this Privacy Policy or our data practices,
                please contact us at:
              </Typography>
              <Typography variant="body1" component="div" sx={{ pl: 2 }}>
                <strong>FreshSweeper Inc.</strong><br />
                Email: privacy@freshsweeper.com<br />
                Phone: 973-380-4757<br />
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
};

export default PrivacyPolicy;